import "@hotwired/turbo-rails"
import "../../controllers"
import "../../controllers/website"
import { initializeAxeptio } from "../../lib/axeptio"
import { initializeFaciliti } from "../../lib/faciliti"
import { initializeVisitTracking } from "../../lib/visit_tracking"

initializeAxeptio()
initializeFaciliti()
initializeVisitTracking()
